import { Button } from '@/components/ui/button';
import { ArrowRight, Shield, Users, Clock, Award } from 'lucide-react';

const Hero = () => {
  const scrollToAppointment = () => {
    const element = document.querySelector('#appointment');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToAbout = () => {
    const element = document.querySelector('#about');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center">
      {/* Background com gradiente */}
      <div className="absolute inset-0 gradient-hero opacity-95"></div>
      
      {/* Imagem de fundo */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('/images/clinic_reception_1.jpeg')`,
        }}
      ></div>

      {/* Overlay */}
      <div className="absolute inset-0 bg-black/40"></div>

      {/* Conteúdo */}
      <div className="relative z-10 container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Texto principal */}
          <div className="text-white animate-fade-in-up">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6">
              Cuidando da sua
              <span className="block text-accent"> saúde mental</span>
              com excelência
            </h1>
            
            <p className="text-xl md:text-2xl mb-8 text-gray-200 leading-relaxed">
              Clínica multidisciplinar especializada em psicologia, psicanálise, 
              fonoaudiologia e muito mais. Seu bem-estar é nossa prioridade.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-12">
              <Button 
                onClick={scrollToAppointment}
                size="lg"
                className="bg-accent text-accent-foreground hover:bg-accent/90 transition-smooth text-lg px-8 py-4"
              >
                Agendar Consulta
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
              
              <Button 
                onClick={scrollToAbout}
                variant="outline"
                size="lg"
                className="border-white text-white hover:bg-white hover:text-gray-900 transition-smooth text-lg px-8 py-4"
              >
                Conheça a Clínica
              </Button>
            </div>

            {/* Estatísticas */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              <div className="text-center">
                <div className="text-3xl font-bold text-accent mb-2">10+</div>
                <div className="text-sm text-gray-300">Anos de Experiência</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-accent mb-2">8</div>
                <div className="text-sm text-gray-300">Especialidades</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-accent mb-2">15+</div>
                <div className="text-sm text-gray-300">Profissionais</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-accent mb-2">1000+</div>
                <div className="text-sm text-gray-300">Pacientes Atendidos</div>
              </div>
            </div>
          </div>

          {/* Cards de destaque */}
          <div className="animate-slide-in-right">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <Shield className="h-12 w-12 text-accent mb-4" />
                <h3 className="text-xl font-semibold text-white mb-2">
                  Atendimento Seguro
                </h3>
                <p className="text-gray-200">
                  Protocolos rigorosos de segurança e privacidade para seu bem-estar.
                </p>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <Users className="h-12 w-12 text-accent mb-4" />
                <h3 className="text-xl font-semibold text-white mb-2">
                  Equipe Especializada
                </h3>
                <p className="text-gray-200">
                  Profissionais qualificados e experientes em diversas áreas.
                </p>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <Clock className="h-12 w-12 text-accent mb-4" />
                <h3 className="text-xl font-semibold text-white mb-2">
                  Horários Flexíveis
                </h3>
                <p className="text-gray-200">
                  Agendamento online com horários que se adaptam à sua rotina.
                </p>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <Award className="h-12 w-12 text-accent mb-4" />
                <h3 className="text-xl font-semibold text-white mb-2">
                  Excelência Reconhecida
                </h3>
                <p className="text-gray-200">
                  Referência em atendimento multidisciplinar na região.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white rounded-full mt-2 animate-pulse-soft"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;